export default {
  listAccountTypes: [],
  accountType: {
    descricao: '',
    ativo: true,
  },
  comboBanks: [],
}
